import React from 'react';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Sarah Mitchell',
    role: 'Senior Agent, Ray White',
    text: 'ListingLens cut my listing prep time from 3 hours to 20 minutes. The AI descriptions are better than what I used to write manually.',
    rating: 5
  },
  {
    name: 'James Al-Rashid',
    role: 'Property Developer, Dubai',
    text: 'Bulk upload saved us weeks of work when launching our 80-unit project. The automated market analysis was spot on.',
    rating: 5
  },
  {
    name: 'Priya Sharma',
    role: 'Independent Agent, Sydney',
    text: 'The draft saving feature is a game changer. I can start a listing on my phone and finish it at the office.',
    rating: 5
  }
];

const integrations = ['Domain', 'REA Group', 'Bayut', 'Property Finder', 'Zillow', 'Rightmove'];

const TrustSection = () => {
  return (
    <section className="py-20 px-4" id="trust">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8F4FD' }}>Trusted by 5,000+ Agents</h2>
          <p className="text-base" style={{ color: '#6B9EC4' }}>Real results from real estate professionals worldwide.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {testimonials?.map((t, i) => (
            <div key={i} className="p-6 rounded-2xl" style={{
              background: 'rgba(0, 212, 255, 0.04)',
              border: '1px solid rgba(0, 212, 255, 0.12)'
            }}>
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t?.rating })?.map((_, j) => (
                  <Star key={j} size={14} fill="#FFB800" color="#FFB800" />
                ))}
              </div>
              <p className="text-sm leading-relaxed mb-5" style={{ color: '#A0C4D8' }}>"{t?.text}"</p>
              <div>
                <div className="text-sm font-semibold" style={{ color: '#E8F4FD' }}>{t?.name}</div>
                <div className="text-xs" style={{ color: '#4A7A9B' }}>{t?.role}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {[
            { value: '5,000+', label: 'Active Agents' },
            { value: '120K+', label: 'Listings Created' },
            { value: '2.8M', label: 'Leads Generated' },
            { value: '98%', label: 'Uptime SLA' },
          ]?.map((stat, i) => (
            <div key={i} className="p-5 rounded-2xl text-center" style={{
              background: 'rgba(0, 212, 255, 0.06)',
              border: '1px solid rgba(0, 212, 255, 0.15)'
            }}>
              <div className="text-2xl font-bold mb-1" style={{ color: '#00D4FF' }}>{stat?.value}</div>
              <div className="text-xs" style={{ color: '#4A7A9B' }}>{stat?.label}</div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-sm mb-6" style={{ color: '#4A7A9B' }}>Publish directly to major property portals</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {integrations?.map((name, i) => (
              <div key={i} className="px-4 py-2 rounded-lg text-sm font-medium" style={{
                background: 'rgba(0, 212, 255, 0.06)',
                border: '1px solid rgba(0, 212, 255, 0.15)',
                color: '#6B9EC4'
              }}>
                {name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
